// extracted by mini-css-extract-plugin
export var bgImage = "header-background-module--bgImage--cceb7";
export var containerHeader = "header-background-module--containerHeader--d7ab2";
export var excerpt = "header-background-module--excerpt--1e0a4";
export var header = "header-background-module--header--f0736";
export var topic = "header-background-module--topic--228c5";